import { EntryFiltersModel } from "@app/data-hooks/use-entries-data.ts";
import usePowerBiReportsData from "@app/data-hooks/use-power-bi-reports-data.ts";
import { Button, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Dialog } from "bi-lib";
import { useState } from "react";

interface Props {
    open: boolean;
    onClose: () => void;
    filters: EntryFiltersModel;
}

export default function EntryReportModal({ open, onClose, filters }: Props) {
    const [reportId, setReportId] = useState<number | null>(null);

    const { generateReport } = usePowerBiReportsData();

    const handlePrint = async () => {
        await generateReport.mutateAsync({
            reportId: reportId!,
            parameters: {
                fromDt: filters.from,
                toDt: filters.to,
                staffId: filters.staffId == undefined ? undefined : [+filters.staffId],
                assignmentId: filters.assignmentId == undefined ? undefined : +filters.assignmentId,
                postedId: filters.isPosted,
                activeId: filters.activeAssignmentsOnly,
                billableId: filters.isBillable,
                invoiceVisibleId: filters.InvoiceVisible,
            },
        });

        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth={"sm"} fullWidth>
            <DialogTitle>Timesheet Reports</DialogTitle>
            <DialogContent>
                <RadioGroup value={reportId} onChange={(e) => setReportId(+e.target.value)}>
                    <FormControlLabel value={16} control={<Radio />} label={"Consultant Invoice"} />
                    <FormControlLabel value={17} control={<Radio />} label={"Consultant Timesheet"} />
                    <FormControlLabel value={18} control={<Radio />} label={"Summary Timesheet"} />
                    <FormControlLabel value={20} control={<Radio />} label={"Detail Timesheet"} />
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant={"outlined"}>
                    Close
                </Button>
                <Button onClick={handlePrint} variant={"contained"}>
                    Print
                </Button>
            </DialogActions>
        </Dialog>
    );
}
